export const config = {
  tanstack: {
    refetchInterval: 30 * 1000, // 30 seconds
    baseSigningProcessesQueryKey: 'signing-processes',
    baseSigningProcessesStatusCountsQueryKey: 'signing-processes-status-counts',
  },
};
